import axios from '@axios';
import { ErrorMessage } from '@/libs/Error';

export default class SisDkpClienteTokenClient {
  constructor() {
    this.api = axios;
    this.error = new ErrorMessage();
  }

  async getDkpClientesTokens(queries = {}) {
    try {
      const { data } = await this.api.get('/cliente-tokens', { params: queries });
      return data;
    } catch (error) {
      throw this.error.message(error, 'Erro ao listar os CLientes Tokens');
    }
  }

  async postDkpClientesToken(body) {
    try {
      const { data } = await this.api.post('/cliente-tokens', body);
      return data;
    } catch (error) {
      throw this.error.message(error, 'Erro ao criar o Cliente');
    }
  }

  async deleteDkpClientesTokenIdSoftDelete(id) {
    try {
      const { data } = await this.api.delete(`/cliente-tokens/${id}/softDelete`);
      return data;
    } catch (error) {
      throw this.error.message(error, 'Erro ao deletar o Cliente');
    }
  }

  async putDkpClientesTokenId(id, body) {
    try {
      const { data } = await this.api.put(`/cliente-tokens/${id}`, body);
      return data;
    } catch (error) {
      throw this.error.message(error, 'Erro ao editar o Cliente');
    }
  }
}
